// src/components/update-available-banner.tsx
import React from 'react';
import { useAppUpdate } from '../contexts/app-update-context';

export const UpdateAvailableBanner: React.FC = () => {
  const { triggerUpdate, dismissUpdate } = useAppUpdate();

  return (
    <div
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1001,
        background: '#2b2d33',
        padding: '12px 20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        animation: 'updateBannerSlideIn 300ms ease-out',
      }}
    >
      <span
        style={{
          color: '#E1C27A',
          fontSize: 14,
          fontFamily: 'Inter, system-ui, sans-serif',
          fontWeight: 500,
        }}
      >
        A new version is available
      </span>

      <button
        onClick={triggerUpdate}
        style={{
          color: '#5E84ED',
          background: 'transparent',
          border: 'none',
          fontSize: 14,
          fontFamily: 'Inter, system-ui, sans-serif',
          fontWeight: 600,
          cursor: 'pointer',
          padding: '4px 8px',
        }}
      >
        Update Now
      </button>

      <button
        onClick={dismissUpdate}
        aria-label="Dismiss"
        style={{
          color: 'rgba(255,255,255,0.4)',
          background: 'transparent',
          border: 'none',
          fontSize: 18,
          cursor: 'pointer',
          padding: '2px 6px',
          lineHeight: 1,
        }}
      >
        &times;
      </button>

      <style>
        {`
          @keyframes updateBannerSlideIn {
            from { transform: translateY(-100%); opacity: 0; }
            to   { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};
